<template>
    <div class="row g-3 p-3 shadow justify-content-center bg-white border-20">
        <header class="row w-100 header justify-content-center py-3">
            <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
                <div class="d-flex align-items-center justify-content-center border-20 hedaeritem active">
                    دریافت موضوع از سیستم
                </div>
            </div>
            <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
              <router-link :to="'/ai/customwriting'">
                <div class="d-flex align-items-center justify-content-center border-20 hedaeritem">
                    ایجاد موضوع دلخواه
                </div>
              </router-link>
            </div>
            <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
              <router-link :to="'/ai/writing/list'">
                <div class="d-flex align-items-center justify-content-center border-20 hedaeritem">
                    فهرست آزمون های انجام شده
                </div>
              </router-link>
            </div>
        </header>
        <div class="col-12"><p class="para mt-3 text-center">در این قسمت می‌توانید برای امتحان آیلتس موضوع تمرین نوشتاری (Writing) دریافت کنید.</p></div>
        <div class="col-12"><p class="para mt-1 text-center">سیستم هوشمند ما پس از ارائه موضوع و مشخص‌نمودن تکلیف، به پاسخ‌های شما نمره خواهد داد.</p></div>        
        <div class="col-12">
            <div class="w-100 d-flex align-items-center justify-content-center mt-3">
                <div @click="sav()" class="d-flex align-items-center justify-content-center addtopic2">ایجاد موضوع توسط سیستم</div>
            </div>
        </div>
        <div class="col-12">
            <div class="w-100 d-flex align-items-start flex-wrap mt-3">
              <div class="col-12 col-md-12 col-xl-2 col-lg-2 mt-2 mt-md-2 mt-xl-0 mt-lg-0 d-flex align-items-center justify-content-center justify-content-md-center justify-content-lg-end justify-content-xl-end order-2 order-md-2 order-xl-1 order-lg-1">
                <span @click="savToTable()" class="d-flex align-items-center justify-content-center ml-2 savetopic">تایید موضوع</span>
              </div>
              <div name="topic" id="topic" class="col-12 col-md-12 col-xl-10 col-lg-10  textarea text-left p-2 d-flex order-1 order-md-1 order-xl-2 order-lg-2" placeholder="Your topic will be displayed here">Your topic will be displayed here</div>
            </div>
        </div>
    </div>
    </template>
  
  <script>
  import btn from "../../../UI/button/btn.vue";
  import textInput from "../../../UI/input/textInput.vue";
  import selectInput from "../../../UI/input/selectInput.vue";
  import userImg from "../../../UI/userImg/userImg.vue";
  import pageNavigation from "../../../UI/pageNavigation/pageNavigation.vue";
  import previewImage from "../../../UI/uploadFile/previewImage.vue";
  import { indexFinder } from "../../../assets/library/filter.js";
  
  export default {
    name: "self_part1",
    data() {
      return {
        imgurl: window.imgurl,
        baseurl: window.baseurl,
        location: { ok: false, data: [] },
        degrees: { ok: false, data: [] },
        field: { ok: false, data: [] },
        category: { ok: false, data: [] },
        username: [],
        indexFinder: indexFinder,
        val: {
          lP: "",
          lC: "",
          d: "",
          c: "",
          f: "",
          e: "",
        },
        topic: ''
      };
    },
    components: {
      btn,
      textInput,
      selectInput,
      pageNavigation,
      userImg,
      previewImage,
    },
    props: {
      flds: {
        default: [],
      },
    },
    mounted() {
      this.getLocation();
    },
    methods: {
      getLocation(THIS = this) {
        window.$.get(
          this.baseurl + "location/list",
          {},
          function (D) {
            THIS.location = D;
            THIS.getField();
          },
          "json"
        );
      },
      getField(THIS = this) {
        window.$.get(
          this.baseurl + "field/list",
          {},
          function (D) {
            THIS.field = D;
          },
          "json"
        );
      },
      //**********************************************************************
  
      //**********************************************************************
      sav(THIS = this) {
        const formdata = new FormData();
        var conversation_id = this.$localStorage.get('conversation_id') ? this.$localStorage.get('conversation_id') : 1;
        formdata.append("user_id", this.$localStorage.get('user').username.id);
        formdata.append("conversation_id", this.$localStorage.get('user').username.id + conversation_id);

        const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow"
        };

        fetch(THIS.baseurl + "ai/gettopic", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          document.getElementById('topic').innerHTML = result.data.replace(/\\n/g, '<br />');
          document.getElementById('topic').style.height = 'auto';
          THIS.topic = result.data;
          // this.$localStorage.set('conversation_id', conversation_id+1)
        })
        .catch((error) => console.error(error));
      },
      savToTable(THIS = this) {
        var topic = THIS.topic;
        var user_id = this.$localStorage.get('user').username.id;
        var type = 'auto';
        if(topic && user_id && type) {
          window.$.post(this.baseurl+'ai/savetopic', 
            { 
              user_id: user_id,
              topic: topic,
              type: type
            }, function(D){
            if(D){
              console.log('d:', D);
              THIS.$router.push('/ai/writing/'+D.data);
            }
          }, "json");
        }
      },
    },
  };
  </script>
  <style>
  .border-20 {
    border-radius: 20px;
  }
  
  .headerai > h4 {
    font-size: 14px;
    font-weight: 400 !important;
    color: #000;
  }
  
  .ai-item {
    height: 240px;
    border: 2px solid #eee7d0;
    cursor: pointer;
    box-shadow: 0;
    transition: 0.3s ease-in-out;
  }
  
  .ai-item:hover {
    box-shadow: 0px 4px 4px 0px #00000040;
    background-color: #fffcf8 !important;
    transition: 0.3s ease-in-out;
  }
  
  .ai-item  header  h3 {
    color: #000;
    font-size: 14px;
    font-weight: 800;
  }
  
  .ai-item.disable  header  h3 {
    color: #676767;
  }
  .hedaeritem {
    height: 72px;
    background-color: #F0F0F0;
    font-size: 14px;
    font-weight: 800;
    color: #808285;
  }
  
  .hedaeritem.active {
    background-color: #FFF7E9;
    box-shadow: 0px 4px 4px 0px #00000040;
    color: #000;
  }

  .header {
    border-bottom: 1px solid #D1D3D4;
  }
  .para {
    font-size: 11px;
    color: #000;
  }
  .addtopic2 {
    border-radius: 10px;
    width: 278px;
    height: 44px;
    font-size: 12px;
    font-weight: 800;
    background-color: #1b60c6 !important;
    color: #fff !important;
    cursor: pointer;
  }
  .savetopic {
    border: 1px solid #C6C6C6;
    height: 60px;
    width: 104px;
    background-color: #F5FAFD;
    font-size: 14px;
    color: #676767;
    border-radius: 10px;
    cursor: pointer;
  }

  .textarea {
    min-height: 60px;
    border: 1px solid #C6C6C6;
    background-color: #F5FAFD;
    font-size: 14px;
    color: #676767;
    border-radius: 10px;
  }
  </style>